import { SceneFeature } from './SceneFeature';

export type FeatureFactory = (options: Record<string, any>) => SceneFeature;

export class SceneFeatureRegistry {
  private factories = new Map<string, FeatureFactory>();

  register(name: string, factory: FeatureFactory): void {
    this.factories.set(name, factory);
  }

  create(name: string, options: Record<string, any>): SceneFeature {
    const factory = this.factories.get(name);
    if (!factory) {
      throw new Error(`Unknown scene feature: '${name}'`);
    }
    return factory(options);
  }

  has(name: string): boolean {
    return this.factories.has(name);
  }
}
